import { FETCH_EDITION_ARTICLES_TYPE } from '../actions';
import createFetchReducer, {
  createItemSetsFromSliceContentGetter,
  createItemSetsFromSlicesGetter,
} from './createFetchReducer';

const initialState = {};

export default createFetchReducer({
  initialState,
  actionType: FETCH_EDITION_ARTICLES_TYPE,
  itemTypePlural: 'articles',
  itemIdName: 'slug',
  getItemSetsFromSlices: createItemSetsFromSlicesGetter({
    getItemSetsFromSliceContent: createItemSetsFromSliceContentGetter({
      sliceTypes: ['edition_tray'],
      filterKeys: [
        'gender',
        'categories',
        'tags',
        'query',
      ],
    }),
  }),
});
